// extracted by mini-css-extract-plugin
export default {"infoRow":"styles_infoRow__xMTtT","infoText":"styles_infoText__k4l0w","infoLogoRow":"styles_infoLogoRow__gEfQC"};